import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "../Actions/PromotionActions";

const initialState = {
    status: 200,
    isLoading: false,
    message: "",
    header: {},
    data: [],
    usersStatus: [],
    lastPage: false,
    refresh: false,
    type: [],
    module: []
};

const PromotionStore = useGlobalHook(React, initialState, actions);

export default PromotionStore;
